module.exports = function getResource(label, vars = []) {
    let resources = {
        foundation: 'Fond de teint',
        concealer: 'Anticernes'
    };
    return resources[label];
};
